import axios from 'axios'
  export const api = axios.create({
    baseURL: process.env.REACT_APP_API_PROXY_URL, // our API base URL
  });

  // Request interceptor for adding the bearer token
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token') // localStorage
      const email = localStorage.getItem('email') 

      if (token && email) {
        config.headers['X-User-Token'] = token
        config.headers['X-User-Email'] = email
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // api.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.response && error.response.status === 401) {
  //       localStorage.removeItem('token');
  //       localStorage.removeItem('email');

  //       // You could use a router hook instead if you're inside a component
  //       window.location.href = '/';
  //     }
  //     return Promise.reject(error);
  //   }
  // );